<div class="breadcrumb-area">
	<h1>Parámetros COA</h1>
</div>
<div class="card mb-5">
    <div class="card-header">
		<h3>Lista de Parámetros 
            <a (click)="creating = true" *ngIf="!creating"><i class="a-hover fa fa-plus"></i></a>
            <a (click)="creating = false" *ngIf="creating"><i class="a-hover fa fa-subtract"></i></a>
        </h3>
	</div>
    <div class="card-body">
        <div class="row align-items-end mb-4" *ngIf="creating">
            <div class="col-md-4 form-group mb-4">
                <label for="parameter" class="form-label">Parámetro</label>
                <input
                type="text"
                [(ngModel)]="parameterData.parameter"
                name="parameter"
                id="parameter"
                class="form-control"
                placeholder="Acidez"
                />
            </div>
            <div class="col-md-3 form-group mb-4">
                <label for="method" class="form-label">Método</label>
                <input
                type="text"
                [(ngModel)]="parameterData.method"
                name="method"
                id="method"
                class="form-control"
                placeholder="Ac-1234"
                />
            </div>
            <div class="col-md-3 form-group mb-4">
                <label for="unit" class="form-label">Unidad</label>
                <input
                type="text"
                [(ngModel)]="parameterData.units"
                name="unit"
                id="unit"
                class="form-control"
                placeholder="VALUE"
                />
            </div>
            <div class="col form-group mb-4">
                <button class="btn btn-success" (click)="createParameter()"
                    [disabled]="loading || !verifyForm ">
                    <ng-container *ngIf="!loading">
                        <i class="fa fa-floppy-disk"></i>
                    </ng-container>
                    <ng-container *ngIf="loading">
                        <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                        <span role="status"></span>
                    </ng-container> GUARDAR
                </button>
            </div>
        </div>
        <div class="row">
            <div class="input-group input-group-sm mb-3">
			<label for="filter" class="input-group-text">Filtra</label>
			<input type="text" (input)="filter()" [(ngModel)]="filterWord" name="filter"
				placeholder="Ingresa el parámetro o método o unidad" id="filter" class="form-control">
		    </div>
            <div class="table table-responsive">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th class="ta">
                                Parámetro
                            </th>
                            <th>
                                Método
                            </th>
                            <th>
                                Unidad
                            </th>
                            <th class="text-center justify-center">
                                Acciones
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let item of filterParameters">
                            <tr>
                                <td>{{item.parameter}}</td>
                                <td>{{item.method}}</td>
                                <td>{{item.units}}</td>
                                <td class="text-center justify-center gap-2">
                                    <!-- <span class="a-hover text-info" (click)="initEditing(item)"><i class="fa fa-edit"></i></span> -->
                                    <span class="a-hover text-danger ml-2" (click)="deleteParameter(item)"><i class="fa fa-trash"></i></span>
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>
            <div class="relative-graph" style="min-height: 350px;" *ngIf="loadingData">
                <div class="absolute-loading" *ngIf="loadingData">
                    <span class="display-5 text-center">
                        <app-loading-animation [height]="'3rem'"></app-loading-animation>
                        Cargando...
                    </span>
                </div>
                <div class="absolute-loading" *ngIf="!loadingData && filterParameters.length == 0">
                    <span class="display-5 text-center">
                        <div class="empty-icon-container">
                            <div class="empty-icon-animation">
                                <i class="fa-solid fa-exclamation"></i>
                            </div>
                            <i class="fa fa-list"></i>
                        </div>
                        No se cuenta con registros
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>